import * as React from 'react'
import { cva } from 'class-variance-authority'

import { cn } from '@components/../lib/utils'

const alertVariants = cva(
  'relative w-full rounded-DEFAULT border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4',
  {
    variants: {
      variant: {
        default: 'bg-card text-foreground border-border [&>svg]:text-foreground',
        destructive: 'border-destructive/50 text-destructive [&>svg]:text-destructive',
        success: 'border-success/50 bg-success-light text-success [&>svg]:text-success',
        warning: 'border-warning/50 bg-warning-light text-warning [&>svg]:text-warning',
        info: 'border-info/50 bg-info-light text-info [&>svg]:text-info'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
)

const Alert = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div ref={ref} role='alert' className={cn(alertVariants({ variant }), className)} {...props} />
))
Alert.displayName = 'Alert'

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h5 ref={ref} className={cn('mb-1 font-medium leading-none tracking-tight', className)} {...props} />
))
AlertTitle.displayName = 'AlertTitle'

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('text-sm [&_p]:leading-relaxed', className)} {...props} />
))
AlertDescription.displayName = 'AlertDescription'

export { Alert, AlertTitle, AlertDescription }
